import { useRef } from "react";

interface InputMachineNumberProps {
  machineNumber: string;
  setMachineNumber: React.Dispatch<React.SetStateAction<string>>;
}

export const InputMachineNumber: React.FC<InputMachineNumberProps> = ({
  machineNumber,
  setMachineNumber,
}) => {
  const INPUT_FORM_MAX_LENGTH = 6; // 半角文字の最大数
  // IME 変換中かどうかのフラグ
  const isImeOn = useRef(false);
  //入力フォーム用
  const inputRef = useRef(null);

  const handleChange = (inputText: string) => {
    let length = 0;
    let formattedValue = "";
    if (inputText === "") {
      // Memo:Chrome ではテキストクリア時に onCompositionEnd が呼ばれないことがある
      isImeOn.current = false;
    } else if (isImeOn.current) {
      return; // IME 変換中は何もしない
    }
    for (let char of inputText) {
      //console.log("char: ", char);
      // eslint-disable-next-line no-control-regex
      if (char.match(/[0-9a-zA-Z]/)) {
        //半角英数字のみ入力を採用
        length += 1;
        formattedValue += char;
      }
      if (length >= INPUT_FORM_MAX_LENGTH) {
        break;
      }
    }
    //return input;
    if (inputRef.current) {
      (inputRef.current as HTMLInputElement).value = formattedValue; //加工後の値を入力フォームに設定
    }
    setMachineNumber(formattedValue);
  };

  return (
    <input
      ref={inputRef}
      type="text"
      className="block appearance-none bg-white placeholder-gray-500 border border-sub-blue rounded w-11/12 py-3 px-4 mx-auto 
    text-black leading-5 focus:outline-none  focus:placeholder-gray-500"
      defaultValue={machineNumber}
      maxLength={INPUT_FORM_MAX_LENGTH}
      onChange={(e) => {
        handleChange(e.target.value);
      }}
      onCompositionStart={() => {
        isImeOn.current = true; // IME 入力中
      }}
      onCompositionEnd={(e) => {
        isImeOn.current = false; // IME 入力完了
        handleChange((e.target as HTMLInputElement).value);
      }}
    />
  );
};
